export default __webpack_public_path__ + "static/bannerImg-22df36aff9af4b1fa03f9d2ba840b74f.webp";